import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";

export default function MenuTab() {
  const [form, setForm] = useState(null);

  useEffect(() => {
    api("/settings")
      .then((s) =>
        setForm({
          nav: (s.nav_items || []).map((n) => `${n.label} | ${n.href}`).join("\n"),
          instagram_url: s.instagram_url || "",
          facebook_url: s.facebook_url || "",
          footer_tagline: s.footer_tagline || "",
        })
      )
      .catch((e) => toast.error(e.message));
  }, []);

  if (!form) return <p className="font-display italic text-gold">Loading</p>;
  const set = (k, v) => setForm({ ...form, [k]: v });

  const save = async () => {
    try {
      const nav_items = form.nav
        .split("\n").map((l) => l.trim()).filter(Boolean)
        .map((l) => {
          const [label = "", href = ""] = l.split("|").map((p) => p.trim());
          return { label, href };
        });
      await api("/admin/settings", {
        method: "PUT",
        body: { data: { nav_items, instagram_url: form.instagram_url, facebook_url: form.facebook_url, footer_tagline: form.footer_tagline } },
      });
      toast.success("Menu and socials updated");
    } catch (e) {
      toast.error(e.message);
    }
  };

  return (
    <div data-testid="menu-tab">
      <h2 className="font-display text-3xl text-ink">Menu and Socials</h2>
      <p className="mt-2 text-sm text-neutral-500">Control the site navigation, social links and footer tagline.</p>

      <div className="mt-8 space-y-6">
        <div>
          <label className="block text-[10px] uppercase tracking-[0.25em] text-gold font-semibold mb-2">Navigation Items</label>
          <p className="text-xs text-neutral-500 mb-2">One per line: Label | /path. Example: The Edit | /edit. Pages marked in menu appear automatically after these.</p>
          <textarea data-testid="menu-nav-input" rows={6} value={form.nav} onChange={(e) => set("nav", e.target.value)}
            className="w-full border border-ink/15 px-4 py-3 text-sm outline-none focus:border-gold bg-white font-mono" />
        </div>
        <div className="grid md:grid-cols-2 gap-5">
          <div>
            <label className="block text-[10px] uppercase tracking-[0.25em] text-gold font-semibold mb-2">Instagram URL</label>
            <input data-testid="menu-instagram-input" value={form.instagram_url} onChange={(e) => set("instagram_url", e.target.value)}
              className="w-full border border-ink/15 px-4 py-3 text-sm outline-none focus:border-gold bg-white" />
          </div>
          <div>
            <label className="block text-[10px] uppercase tracking-[0.25em] text-gold font-semibold mb-2">Facebook URL</label>
            <input data-testid="menu-facebook-input" value={form.facebook_url} onChange={(e) => set("facebook_url", e.target.value)}
              className="w-full border border-ink/15 px-4 py-3 text-sm outline-none focus:border-gold bg-white" />
          </div>
        </div>
        <div>
          <label className="block text-[10px] uppercase tracking-[0.25em] text-gold font-semibold mb-2">Footer Tagline</label>
          <input data-testid="menu-tagline-input" value={form.footer_tagline} onChange={(e) => set("footer_tagline", e.target.value)}
            className="w-full border border-ink/15 px-4 py-3 text-sm outline-none focus:border-gold bg-white" />
        </div>
        <button onClick={save} data-testid="menu-save-button"
          className="bg-ink text-cream px-8 py-3.5 text-xs uppercase tracking-[0.3em] font-semibold hover:bg-gold transition-colors duration-300">
          Save Menu
        </button>
      </div>
    </div>
  );
}
